import { FormSpy, useForm } from 'react-final-form'

const DefaultFormSpy = ({ onChange }) => {
  const form = useForm()
  return <FormSpy subscription={{ values: true }} onChange={(values) => onChange(values, form)} />
}

export default DefaultFormSpy
